import { Component, Input, ElementRef, EventEmitter, Output, OnInit, forwardRef, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../core';
import { Classificacao } from '../classificacao';
import { ClassificacaoFilter } from '../filter/classificacao-filter';
import { ClassificacaoCrudHttpService } from '../services';
import { classificacaoAtiva, isSituacaoInativa } from '../classificacao-situacao';

@Component({
    selector: 'sgt-classificacao-select',
    templateUrl: './classificacao-select.component.html',
    styleUrls: ['./classificacao-select.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ClassificacaoSelectComponent), multi: true },
    ]
})
export class ClassificacaoSelectComponent implements OnInit, OnChanges {
    classificacoes: Classificacao[];

    /** ID da classificação */
    @Input() ngModel: number;
    /** Ao alterar a classificação selecionada */
    @Output() ngModelChange = new EventEmitter<number>();

    /** Objeto da classificação */
    @Input() classificacao: Classificacao;
    @Output() classificacaoChange = new EventEmitter<Classificacao>();

    /** Se é obrigatório informar o tipo da classificação no filtro para pesquisar */
    @Input() tipoClassificacaoFilterRequired = false;
    /** ID do tipo da classificação */
    @Input() idTipoClassificacao: number;
    /** Ao alterar o tipo da classificação selecionada */
    @Output() idTipoClassificacaoChange = new EventEmitter<number>();
    /** Nome do tipo da classificação */
    @Input() nomeTipoClassificacao: string;

    /** Cadastro do Tipo de Classificação para filtrar */
    @Input() cadastroTipoClassificacao: number;

    /** Nivel do Tipo de Classificação para filtrar */
    @Input() nivelTipoClassificacao: number;

    /** Classificação Pai para filtrar */
    @Input() idClassificacaoPai: number;

    /**
     * Nome do input
     */
    @Input() name: string;
    /**
     * ID do input
     */
    @Input() id: string;
    /**
     * Se o valor é obrigatório
     */
    @Input() required: any;
    /**
     * Se deve desabilitar o input
     */
    @Input() disabled: boolean;

    /** Se deve filtrar somente as classificações ativias */
    @Input() somenteAtivas = false;

    @ViewChild('select') select: ElementRef;

    propagateChange: any = () => {};

    constructor(private messageService: MessageService,
                private classificacaoCrudHttpService: ClassificacaoCrudHttpService) { }

    ngOnInit() {
        this.search();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (!changes[propName].isFirstChange()) {
                if (propName === 'idTipoClassificacao' ||
                    propName === 'cadastroTipoClassificacao' ||
                    propName === 'nivelTipoClassificacao' ||
                    propName === 'idClassificacaoPai') {
                        this.search();
                }
            }
        };
    }

    /** Verifica se a classificação do item esta inativa */
    isSituacaoInativa(situacao: number): boolean {
        return isSituacaoInativa(situacao);
    }

    /** Cria o filtro para pesquisar as classificações */
    private createFilter(): ClassificacaoFilter {
        const filter = new ClassificacaoFilter();
        // Somente ativas
        if (this.somenteAtivas) {
            filter.situacao = classificacaoAtiva.id;
        }
        // Tipo da Classificação
        if (this.idTipoClassificacao) {
            filter.idTipoClassificacao = this.idTipoClassificacao;
        }
        // Cadastro do Tipo de Classificação
        if (this.cadastroTipoClassificacao) {
            filter.cadastrosTipoClassificacao = [this.cadastroTipoClassificacao];
        }
        // Nivel do Tipo de Classificação
        if (this.nivelTipoClassificacao != null && this.nivelTipoClassificacao !== undefined) {
            filter.niveisTipoClassificacao = [this.nivelTipoClassificacao];
        }
        // Classificação Pai
        if (this.idClassificacaoPai) {
            filter.idClassificacaoPai = this.idClassificacaoPai;
        }

        return filter;
    }

    /** Pesquisa os grupos das classificações pelo tipo */
    private search() {
        this.classificacoes = [];

        // Filtro do tipo da classificação obrigatório
        if (this.tipoClassificacaoFilterRequired && !this.idTipoClassificacao) {
            return;
        }

        const filter = this.createFilter();
        this.classificacaoCrudHttpService.searchWithFilter(filter)
            .pipe(
                take(1)
            )
            .subscribe(
                classificacoes => this.classificacoes = classificacoes,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar os segmentos', error)
            );
    }

    /** Ao alterar a classificação */
    onChange(idClassificacao: number) {
        this.ngModel = idClassificacao;
        this.ngModelChange.emit(this.ngModel);

        this.classificacao = this.classificacoes?.find(classificacaoFilter => classificacaoFilter.id === idClassificacao);
        this.classificacaoChange.emit(this.classificacao);

        // Setando os dados do tipo da classificação
        this.idTipoClassificacao = this.classificacao?.idTipoClassificacao;
        this.idTipoClassificacaoChange.emit(this.idTipoClassificacao);
        this.nomeTipoClassificacao = this.classificacao?.nomeTipoClassificacao;
    }

    /** Seta o focus no select */
    setFocus() {
        jQuery(this.select?.nativeElement).trigger('focus');
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
